import React from 'react';
import { useLocation } from 'react-router-dom';
import { X } from 'lucide-react';
import { useChatSupport } from '../contexts/ChatSupportContext';
import { useAuth } from '../contexts/AuthContext';

const FloatingChatButton: React.FC = () => {
  const { isOpen, unreadCount, toggleChat } = useChatSupport();
  const { user } = useAuth();
  const location = useLocation();
  
  // Hide chat button on login/auth pages, PDF export preview, or when user is not authenticated
  const shouldHideButton = !user ||
    location.pathname === '/login' ||
    location.pathname === '/register-admin' ||
    location.pathname === '/pdf-export-preview' ||
    location.pathname.startsWith('/auth');

  if (shouldHideButton) {
    return null;
  }

  return (
    <button
      onClick={toggleChat}
      data-tour="arie-chat"
      className="fixed bottom-6 right-6 z-50 group print:hidden"
      aria-label={isOpen ? 'Close chat' : 'Open chat'}
    >
      <div className="relative">
        {/* Main button */}
        {isOpen ? (
          <div className="w-14 h-14 rounded-full shadow-lg transition-all duration-300 flex items-center justify-center bg-gray-600 hover:bg-gray-700">
            <X className="w-6 h-6 text-white" />
          </div>
        ) : (
          <img
            src="/chat-icon.png"
            alt="Open chat"
            className="w-32 h-32 transition-transform duration-300 hover:scale-110 drop-shadow-lg"
            draggable={false}
          />
        )}
        
        {/* Unread count badge */}
        {!isOpen && unreadCount > 0 && (
          <div className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full flex items-center justify-center animate-pulse">
            <span className="text-white text-xs font-bold">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          </div>
        )}
        
        {/* Pulse animation for attention */}
        {!isOpen && unreadCount > 0 && (
          <div className="absolute inset-0 rounded-full bg-red-400 animate-ping opacity-75" />
        )}
        
      </div>
    </button>
  );
};

export default FloatingChatButton;